import { RouterProvider } from 'react-router-dom';
import router from 'route';
import './helpers/utils/i18n';

function App() {
  return <RouterProvider router={router} />;
}

export default App;
